import { render } from "./ReactivateAccountView.vue?vue&type=template&id=8a9e6ebc"
import script from "./ReactivateAccountView.vue?vue&type=script&lang=js"
export * from "./ReactivateAccountView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__